import { useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { Upload } from 'lucide-react';
import Button from '../../../components/ui/Button';
import { getErrorMessage } from '../../../lib/apiClient';
import { uploadFile } from '../filesApi';

export default function UploadButton({ folderId }) {
  const inputRef = useRef(null);
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);

  const handleFiles = async (fileList) => {
    const files = Array.from(fileList);
    if (!files.length) return;
    setBusy(true);

    for (const file of files) {
      const toastId = toast.loading(`Uploading ${file.name}… 0%`);
      try {
        await uploadFile({
          file,
          folderId,
          onProgress: (pct) => toast.loading(`Uploading ${file.name}… ${pct}%`, { id: toastId }),
        });
        toast.success(`Uploaded ${file.name}`, { id: toastId });
      } catch (error) {
        toast.error(getErrorMessage(error, `Failed to upload ${file.name}`), { id: toastId });
      }
    }

    queryClient.invalidateQueries({ queryKey: ['folder-contents'] });
    queryClient.invalidateQueries({ queryKey: ['me'] });
    setBusy(false);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(e.target.files)}
      />
      <Button loading={busy} onClick={() => inputRef.current?.click()}>
        <Upload className="h-4 w-4" />
        Upload
      </Button>
    </>
  );
}
